import React, { useEffect, useState } from 'react';
import FAQSection from '../components/FAQSection';
import AboutImg from '../assets/images/IMG_0779.JPG';
import AboutImg2 from '../assets/images/IMG_1421.JPG';
import BirndzeImg from '../assets/Team-Partners/Team - Birndze Bete.jpeg';
import NanaImg from '../assets/Team-Partners/Team - Nana Lynn.jpg';
import MahImg from '../assets/Team-Partners/Mah Ekonde.jpeg';
import AtemImg from '../assets/Team-Partners/Atem Synderline.png';
import BritneyImg from '../assets/Team-Partners/Britney Fonki.jpeg';
import CeciliaImg from '../assets/Team-Partners/Cecilia Balemba.jpg';

import BeckelyImg from '../assets/Team-Partners/Clotilde Ameck.jpg';
import FelixImg from '../assets/Team-Partners/Felix Fomengia.PNG';
import HenriImg from '../assets/Team-Partners/Henri Owona.jpg';
import MbiImg from '../assets/Team-Partners/Mbi Vahid.jpg';
import OnizeImg from '../assets/Team-Partners/Oniza Ndichia.jpeg';
import GaetanImg from '../assets/Team-Partners/Gaetan.jpeg';

const About = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">About Us</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> About Us
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="welcome-grid">
            <div>
              <div className="eyebrow">The Problem & The Conviction</div>
              <h2 className="section-title">Rise Locally, Lead Globally</h2>
              <p className="section-body">
                <strong>The problem:</strong> Cameroon's professionals are talented, ambitious and globally competitive - yet massively underrepresented in global networks, platforms and opportunities.
              </p>
              <p className="section-body" style={{ fontSize: 18, fontStyle: 'italic', fontWeight: 600, color: 'var(--blue)', borderLeft: '4px solid var(--red)', paddingLeft: 16, margin: '24px 0' }}>
                "Cameroon does not lack talent. It lacks the platform that makes that talent visible to the world. We build that platform."
              </p>
              <p className="section-body">
                <strong>The conviction:</strong> A team of Cameroonian professionals decided to build the platform that did not exist: a national community to connect, equip and elevate Cameroonian talent.
              </p>
            </div>
            <div className="welcome-img-wrap" style={{ boxShadow: 'var(--shadow-lg)' }}>
              <img src={AboutImg} alt="About LLC" style={{ objectPosition: 'center 10%' }} />
            </div>
          </div>
        </div>
      </section>




      {/* DEMOGRAPHICS */}
      <section className="section section--gray">
        <div className="container">
          <div className="text-center mb-12">
            <div className="eyebrow" style={{ justifyContent: 'center' }}>The Opportunity</div>
            <h2 className="section-title">Who Attends LLC 2026?</h2>
            <p className="section-body">A deliberately curated audience - the most commercially valuable professional demographic in Cameroon.</p>
          </div>

          <div className="who-attends-grid">
            {/* Card 1: Audience Breakdown */}
            <div className="who-attends-card">
              <div>
                <h3 style={{ fontFamily: 'Montserrat', fontSize: 20, fontWeight: 800, color: 'var(--text-dark)', marginBottom: 24 }}>Audience Breakdown</h3>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Corporate Professionals</span>
                    <span className="progress-bar-percent">35%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{ width: '35%', background: 'var(--blue)' }}></div>
                  </div>
                  <p className="progress-bar-desc">Employees at SMEs, multinationals and public sector organizations</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Entrepreneurs & Founders</span>
                    <span className="progress-bar-percent">25%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{ width: '25%', background: 'var(--blue-dark)' }}></div>
                  </div>
                  <p className="progress-bar-desc">Active business owners, startup founders and freelancers</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Students & Graduates</span>
                    <span className="progress-bar-percent">25%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{ width: '25%', background: 'var(--green)' }}></div>
                  </div>
                  <p className="progress-bar-desc">University students and recent graduates entering the workforce</p>
                </div>

                <div className="progress-bar-group">
                  <div className="progress-bar-header">
                    <span className="progress-bar-title">Diaspora & Internationals</span>
                    <span className="progress-bar-percent">15%</span>
                  </div>
                  <div className="progress-bar-track">
                    <div className="progress-bar-fill" style={{ width: '15%', background: 'var(--yellow)' }}></div>
                  </div>
                  <p className="progress-bar-desc">Cameroonian diaspora and international professionals</p>
                </div>
              </div>
            </div>

            {/* Card 2: Cameroon Talent */}
            <div className="who-attends-card who-attends-card--gradient">
              <div>
                <h3 style={{ fontFamily: 'Montserrat', fontSize: 20, fontWeight: 800, color: '#fff', marginBottom: 6 }}>Cameroon Talent</h3>
                <p style={{ fontSize: 13, color: 'rgba(255, 255, 255, 0.7)', marginBottom: 28 }}>The opportunity we are investing in</p>

                <div className="demographics-metric-grid">
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">#1</div>
                    <div className="demographics-metric-label">French-speaking Africa market</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">18</div>
                    <div className="demographics-metric-label">Median age (youngest workforce)</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">60%</div>
                    <div className="demographics-metric-label">Under 25 entering workforce</div>
                  </div>
                  <div className="demographics-metric-item">
                    <div className="demographics-metric-num">26M</div>
                    <div className="demographics-metric-label">Total Population</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3: Photo Overlay Card */}
            <div className="who-attends-card who-attends-card--photo">
              <img src={AboutImg2} alt="Students at LLC" className="who-attends-photo-bg" />
              <div className="who-attends-photo-overlay">
                <span className="who-attends-overlay-tag">LLC 2026 Summit</span>
                <h3 className="who-attends-overlay-title">Connect, Equip, Elevate</h3>
                <p className="who-attends-overlay-desc">
                  Building the bridges to position Cameroon's most talented minds for the world stage.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="section">
        <div className="container text-center">
          <div className="eyebrow" style={{ justifyContent: 'center' }}>The Team</div>
          <h2 className="section-title">The People Behind LLC 2026</h2>
          <p className="section-body" style={{ maxWidth: 660, margin: '0 auto 16px' }}>
            A team of 3 Conveners, 8 Directors, a Board of Advisors and 40+ volunteers — all Cameroonian professionals committed to building this country's most important platform.
          </p>

          {/* CONVENERS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{ justifyContent: 'center' }}>Conveners</div>
            <div className="speakers-grid" style={{ marginTop: '24px', justifyContent: 'center' }}>
              {[
                { 
                  name: 'Nana Lynn', 
                  role: 'Convener & Project Lead', 
                  image: NanaImg, 
                  initials: 'NL',
                  bio: (
                    <>
                      <p><strong>Nana Lynn</strong>, also known as <em>The Boss Lady Coach</em>, is a LinkedIn Optimization Coach and Number 1 LinkedIn Growth Expert in Cameroon 🇨🇲.</p>
                      <p>She is a global speaker, coach and trainer, and has trained more than 2000 professionals on optimizing their profiles and grow for maximum visibility on the world’s largest professional networking platform, LinkedIn through her signature coaching program, The LinkedIn Accelerator Program.</p>
                      <p>Nana Lynn co-founded the LinkedIn Tour Cameroon. An initiative which is bridging the gap between academy and industry and aim to empower 5000+ university students accross Cameroon for career success on LinkedIn and beyond.</p>
                      <p>She is the National President for Jamie Pajoel International (JPI) Cameroon—a global youth leadership organization designed to equip young minds with the skills, knowledge, and mindset needed to excel as leaders and entrepreneurs.</p>
                      <p>As a committed coach, she helps leaders and professionals achieve an impactful online presence and attract lucrative opportunities by leveraging LinkedIn.</p>
                      <p>She is an 8x International Award winner. She was recognized as one of the Top 100 Young Leaders and Innovators in Africa by Jamie Pajoel International in March 2026 in Abuja Nigeria.</p>
                      <p>Nana Lynn won the Cameroon Heroes Impact Awards as an Outstanding Young Cameroonian in April 2026 and was honoured with the Personal Branding Excellence Award by CYES Summit and Awards in July 2026.</p>
                      <p>She won the Cameroon Youth Awards Prize for Young Person of the Year in August 2025. Got a Business Leadership Award from Jamie Pajoel International amongst many great business leaders in Africa in March 2025 in Lagos, Nigeria.</p>
                      <p>What really inspired her to start her coaching journey and founding the LinkedIn Accelerator Program is that she observed that many individuals struggled to navigate the complexities of the job market, build their personal brands, and effectively network.</p>
                      <p>The problem she aims to solve is the lack of practical, and hands-on guidance in using LinkedIn as a powerful tool for career development.</p>
                      <p>Through her program, she offers a structured curriculum that empowers individuals to harness the full potential of LinkedIn with the goal of helping participants stand out in today's competitive professional world.</p>
                      <p>This October 2026, Nana Lynn is set to host LinkedIn Local Cameroon 2026, the largest and biggest professional gathering in Cameroon, welcoming over 2,000 professionals from diverse industries.</p>
                      <p>This landmark event is designed to turn online connections into real-life relationships bringing together business leaders, thought leaders, entrepreneurs, professionals, students, and career-driven individuals under one roof. With one mission; connect, learn, collaborate, and unlock opportunities.</p>
                      <p>Nana Lynn has had several speaking engagements in organizations, companies, and universities and many great communities have benefited from her wealth of wisdom and knowledge. She is available to do more both nationally and internationally🌍.</p>
                      <p style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'var(--blue)', borderLeft: '4px solid var(--red)', paddingLeft: '12px', margin: '16px 0' }}>“Don’t settle for average, don't settle for mediocrity, you are born to do things excellently”.</p>
                      <p>Nana Lynn is a Young Leader and an African with a Solution. She is on a mission to help leaders and professionals take advantage of LinkedIn and the opportunities it has to offer, and she is not stopping anytime soon.</p>
                      <p><strong>Work with Nana Lynn:</strong> Reach out for her services, collaboration, partnerships, speaking engagements, both international and national, global opportunities🌍 and more. It will be an honor for her to work with you.</p>
                    </>
                  )
                },
                { name: 'Birndze Bete', role: 'Convener & Operations Lead', image: BirndzeImg, initials: 'BB' },
                { 
                  name: 'Mah Ekonde', 
                  role: 'Convener & Engagement Lead', 
                  image: MahImg, 
                  initials: 'ME',
                  bio: (
                    <>
                      <p><strong>Mah Ekonde Charlotte</strong> is an award-winning personal branding coach, speaker, author, and Co-Founder of LinkedIn Tour Cameroon and LinkedIn Local Cameroon. She holds a degree in Journalism and Mass Communication from the University of Buea and is passionate about empowering professionals to build visible, credible, and profitable personal brands.</p>
                      <p>As a certified online branding and conscious parenting coach, Mah has mentored and trained over 500+ young professionals and entrepreneurs, equipping them with the skills to discover themselves, increase their visibility, communicate their value, and unlock career and business opportunities through intentional personal branding.</p>
                      <p>Driven by purpose and a commitment to national impact, she is helping shape a new generation of African professionals who lead with authenticity, authority, and wholeness through The Mah Initiative that connects, equips, and positions Cameroonian talent for global opportunities.</p>
                      <p>Mah is also the author of <em>6 Things I Wish I Knew Before Building a Profitable Brand Online</em>, a practical guide for professionals seeking to build a profitable online presence.</p>
                    </>
                  )
                },
              ].map((member, idx) => (
                <div className="speaker-card" key={idx} onClick={() => setSelectedMember(member)} style={{ textAlign: 'left', cursor: 'pointer' }}>
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="speaker-card__photo" style={{ objectFit: 'cover', objectPosition: 'top', height: '320px', width: '100%' }} />
                  ) : (
                    <div className="speaker-card__photo-placeholder" style={{ height: '320px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--blue-light), #d0e8f7)', color: 'var(--blue)', fontSize: '36px', fontWeight: '800', fontFamily: 'Montserrat, sans-serif' }}>
                      {member.initials}
                    </div>
                  )}
                  <div className="speaker-card__info" style={{ padding: '20px' }}>
                    <h3 className="speaker-card__name" style={{ fontSize: '17px', fontWeight: '800', color: 'var(--text-dark)' }}>{member.name}</h3>
                    <div className="speaker-card__role" style={{ fontSize: '13px', color: 'var(--red)', fontWeight: '600', marginTop: '4px' }}>{member.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* BOARD OF DIRECTORS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{ justifyContent: 'center' }}>Board of Directors</div>
            <div className="team-grid-compact">
              {[
                { name: 'Gaetan Njijam', role: 'Director, Event Quality Assurance', initials: 'GN', image: GaetanImg },
                { name: 'Fon Clotilde', role: 'Director, Volunteers & Speaker Management', initials: 'FC' },
                { name: 'Britney Fonki', role: 'Director, Corporate Communications', initials: 'BF', image: BritneyImg },
                { name: 'Cecilia Balemba', role: 'Director, Creative Specialist', initials: 'CB', image: CeciliaImg },
                { name: 'Onize Ndichia', role: 'Director, Social Media Management', initials: 'ON', image: OnizeImg },
                { name: 'Mbi Vahid', role: 'Director, Membership', initials: 'MV', image: MbiImg },
                { name: 'Atem Synderline', role: 'Director, Finance', initials: 'AS', image: AtemImg },
                { name: 'TBA', role: 'Director, Strategic Partnerships', initials: 'SP' },
              ].map((member, idx) => (
                <div className="team-member-compact" key={idx} onClick={() => setSelectedMember(member)} style={{ cursor: 'pointer' }}>
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="team-member-compact__photo" />
                  ) : (
                    <div className="team-member-compact__initials">{member.initials}</div>
                  )}
                  <div className="team-member-compact__name">{member.name}</div>
                  <div className="team-member-compact__role">{member.role}</div>
                </div>
              ))}
            </div>
          </div>

          {/* BOARD OF ADVISORS */}
          <div className="team-section-group">
            <div className="team-section-group__title" style={{ justifyContent: 'center' }}>Board of Advisors</div>
            <div className="team-grid-compact" style={{ maxWidth: 650, margin: '0 auto' }}>
              {[
                { name: 'Dr. Beckely Ehah', role: 'Advisor', initials: 'BE', image: BeckelyImg },
                { name: 'Felix Fomengia', role: 'Advisor', initials: 'FF', image: FelixImg },
                { name: 'Henri Owona', role: 'Advisor', initials: 'HO', image: HenriImg },
              ].map((member, idx) => (
                <div className="team-member-compact" key={idx} onClick={() => setSelectedMember(member)} style={{ cursor: 'pointer' }}>
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="team-member-compact__photo" />
                  ) : (
                    <div className="team-member-compact__initials">{member.initials}</div>
                  )}
                  <div className="team-member-compact__name">{member.name}</div>
                  <div className="team-member-compact__role">{member.role}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FAQSection />

      {/* MEMBER BIO MODAL */}
      {selectedMember && (
        <div 
          style={{ 
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 
            background: 'rgba(0,0,0,0.6)', zIndex: 99999, display: 'flex', 
            alignItems: 'center', justifyContent: 'center', padding: '20px' 
          }}
          onClick={() => setSelectedMember(null)}
        >
          <div 
            style={{ 
              background: '#fff', borderRadius: '12px', maxWidth: '800px', width: '100%', 
              maxHeight: '90vh', overflowY: 'auto', position: 'relative', display: 'flex', flexDirection: 'column' 
            }}
            onClick={e => e.stopPropagation()}
          >
            <button 
              onClick={() => setSelectedMember(null)}
              style={{ 
                position: 'absolute', top: '16px', right: '16px', background: 'transparent', 
                border: 'none', fontSize: '24px', cursor: 'pointer', color: 'var(--text-dark)',
                width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%'
              }}
              onMouseOver={(e) => e.currentTarget.style.background = 'var(--gray-bg)'}
              onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
            >
              ✕
            </button>
            <div style={{ padding: '32px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '24px' }}>
                {selectedMember.image ? (
                  <img src={selectedMember.image} alt={selectedMember.name} style={{ width: '150px', height: '150px', borderRadius: '50%', objectFit: 'cover', marginBottom: '16px', border: '4px solid var(--blue-light)' }} />
                ) : (
                  <div style={{ width: '150px', height: '150px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--blue-light), #d0e8f7)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '48px', fontWeight: '800', color: 'var(--blue)', marginBottom: '16px' }}>
                    {selectedMember.initials}
                  </div>
                )}
                <h3 style={{ fontSize: '24px', fontFamily: 'Montserrat', fontWeight: '800', color: 'var(--text-dark)', marginBottom: '4px' }}>{selectedMember.name}</h3>
                <div style={{ fontSize: '16px', color: 'var(--red)', fontWeight: '600', textAlign: 'center' }}>{selectedMember.role}</div>
              </div>
              <div className="section-body" style={{ fontSize: '15px', color: 'var(--text-body)', display: 'flex', flexDirection: 'column', gap: '16px', lineHeight: '1.7' }}>
                {selectedMember.bio ? selectedMember.bio : <p style={{ textAlign: 'center' }}>Biography coming soon.</p>}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default About;
